export default __webpack_public_path__ + "static/media/7.768d05e2.jpg";